// extracted by mini-css-extract-plugin
export var animationContainer = "_ou-0";
export var footer = "_ou-1";
export var gray = "_ou-2";
export var lineItem = "_ou-3";
export var lineItemImage = "_ou-4";
export var lineItemInfo = "_ou-5";
export var lineItemText = "_ou-6";
export var lineItems = "_ou-7";
export var modalContent = "_ou-8";
export var options = "_ou-9";
export var orderName = "_ou-a";
export var refundAmount = "_ou-b";